import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { Select } from '@nackle/paper';
import { RemoveIcon } from '../icons/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'app/components/shared/spinner/spinner';
import { PersonDetails } from 'app/components/shared/person-details/person-details';
import { getSearchedPeople, setSearchedPeople } from 'app/app-dux/people-dux';

function DebounceSelect( { fetchOptions, debounceTimeout = 800, onTagRemove, onOptionSelect,  ...props } ) {
	const [ fetching, setFetching ] = React.useState( false );
	const [ options, setOptions ] = React.useState( [] );

	const searchedPeople = useSelector( getSearchedPeople );

	const { Option } = Select;
	const fetchRef = React.useRef( 0 );

	const dispatch = useDispatch();

	useEffect( () => {
		setOptions( searchedPeople );
		setFetching( false );
	}, [ searchedPeople ] );

	const debounceFetcher = React.useMemo( () => {
		const loadOptions = ( value ) => {
			fetchRef.current += 1;
			fetchRef.current;
			setOptions( [] );
			setFetching( true );
			if ( value.length > 2 ) {
				fetchOptions( value );
			} else {
				setFetching( false );
			}
		};

		return debounce( loadOptions, debounceTimeout );
	}, [ fetchOptions, debounceTimeout ] );

	const handleOnBlur = ( ) => {
		dispatch( setSearchedPeople( [] ) );
	};
	return (
		<Select
			labelInValue={ true }
			filterOption={ false }
			onSearch={ debounceFetcher }
			notFoundContent={ fetching ? <Spinner loading={ fetching }/> : null }
			onDeselect={ onTagRemove }
			removeIcon={ <RemoveIcon /> }
			onSelect={ ( event, value ) => onOptionSelect( event, value ) }
			onBlur={ ( e ) => handleOnBlur() }
			{ ...props }
		>
			{ options && options.length > 0 &&
				<span disabled>Suggested People</span>
			}
			{ options && options.map( ( person, index ) => {
				return (
					<Option key={ person.id } value={ JSON.stringify( person ) } className="custom-select-option">
						<PersonDetails person={ person } additionalInfo />
					</Option>
				);
			} ) }
		</Select>
	);
}

export default DebounceSelect;

DebounceSelect.propTypes = {
	onTagRemove: PropTypes.func,
	fetchOptions: PropTypes.func,
	debounceTimeout: PropTypes.number
};